export function setDefaultValue(argument: any, defaultvalue: any) {
    return (typeof argument === "undefined" ||
        (typeof argument === "number" && argument.toString() === "NaN") ||
        argument === null ? defaultvalue : argument);
}

export function isEnterKeyPressed(event: any) {
    return ((event.which && event.which === 13) || (event.keyCode && event.keyCode === 13));
};

export function checkEmailAddressOrListValid(emailAddress: string | null | undefined): boolean {
    return CheckEmailAdress.checkEmailAddressOrListValid(emailAddress);
};

export function checkEmailAddressValid(emailAddress: string | null | undefined): boolean {
    return CheckEmailAdress.checkEmailAddressValidOrEmpty(emailAddress);
};

export function checkVerplichtEmailAddressValid(emailAddress: string | null | undefined): boolean {
    return CheckEmailAdress.checkVerplichtEmailAddressValid(emailAddress);
};

export function updateUrlParameter(uri: string, key: string, value: string) {
    return UpdateUrlParameter.updateUrlParameter(uri, key, value);
};

export function getRootUrl(): string {
    return RootUrl.getRootUrl();
};

class CheckEmailAdress {
    public static checkEmailAddressOrListValid(emailAddress: string | null | undefined): boolean {
        let self = this;
        if (!emailAddress) {
            return true;
        }
        let adressen = emailAddress.split(';');
        let returnvalue = false;
        $.each(adressen, function (_index, value) {
            returnvalue = self.checkEmailAddressValidOrEmpty(value.trim());
            return returnvalue; // stop indien er een ongeldig adres is gevonden
        });
        return returnvalue;
    };

    public static checkEmailAddressValidOrEmpty(emailAddress: string | null | undefined): boolean {
        if (!emailAddress) {
            return true;
        }
        return this.isEmailAddressValid(emailAddress);
    };

    public static checkVerplichtEmailAddressValid(emailAddress: string | null | undefined): boolean {
        if (!emailAddress) {
            return false;
        }
        return this.isEmailAddressValid(emailAddress);
    };

    private static isEmailAddressValid(emailAddress: string): boolean {
        // onderstaande regex overgenomen uit de bll van de applicatieserver, zie EmailAdressValidator.cs (aanpassing 20180200358)
        let regEx = /^[\w!#$%&'*+\-/=?\^_`{|}~]+(\.[\w!#$%&'*+\-/=?\^_`{|}~]+)*@((([\-\w]+\.)+[A-Z]{2,})|(([0-9]{1,3}\.){3}[0-9]{1,3}))$/i;
        return regEx.test(emailAddress);
    };
}

class UpdateUrlParameter {
    public static updateUrlParameter(uri: string, key: string, value: string) {
        let hash = this.getHashPartOfUri(uri);
        uri = this.getUriWithoutHashtag(uri);
        let regex = new RegExp("([?&])" + key + "=.*?(&|$)", "i");

        if (!value) {
            uri = this.removeKeyValuePairFromUri(uri, key);
            uri = this.replaceFirstAmpersandWithQuestionmarkIfNoQuestionMarkIsPresent(uri);
        } else if (uri.match(regex)) {
            uri = this.formatKeyValuePairInUriByRegex(uri, regex, key, value);
        } else {
            uri = this.formatKeyValuePairInUriWithSeparator(uri, key, value);
        }
        return uri + hash;
    }

    private static getUriWithoutHashtag(uri: string): string {
        let indexHashtag = uri.indexOf('#');
        return indexHashtag === -1 ? uri : uri.substr(0, indexHashtag);
    }

    private static getHashPartOfUri(uri: string): string {
        let indexHashtag = uri.indexOf('#');
        return indexHashtag === -1 ? '' : uri.substr(indexHashtag);
    }

    private static removeKeyValuePairFromUri(uri: string, key: string): string {
        uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
        if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
        }
        return uri;
    }

    private static replaceFirstAmpersandWithQuestionmarkIfNoQuestionMarkIsPresent(uri: string): string {
        if (uri.indexOf('?') === -1) {
            uri = uri.replace(/&/, '?');
        }
        return uri;
    }

    private static formatKeyValuePairInUriByRegex(uri: string, regex: RegExp, key: string, value: string): string {
        return uri.replace(regex, '$1' + key + "=" + value + '$2');
    }

    private static formatKeyValuePairInUriWithSeparator(uri: string, key: string, value: string): string {
        let separator = this.getUriSeparator(uri);
        return uri + separator + key + "=" + value;
    }

    private static getUriSeparator(uri: string): string {
        return uri.indexOf('?') !== -1 ? "&" : "?";
    }
}

export class RootUrl {
    public static getRootUrl(): string {
        let returnpath = this.getProtocolAndHostPath();
        const href = this.getLocationHref();
        const locationparts = href.split('/');
        const applicationpathIndex = this.getApplicationpathIndex(locationparts);
        const workspacepathIndex = locationparts.indexOf("WSPACES");

        let ext = "";
        if (applicationpathIndex !== -1 && locationparts.length > applicationpathIndex) {
            //applicatie is gevonden 
            ext += "/" + locationparts[applicationpathIndex];

            if (workspacepathIndex !== -1) {
                //er wordt vanuit cockpit gestart, dan ook workspacetyperingen meegeven
                ext += "/" + locationparts[workspacepathIndex] + "/" + locationparts[workspacepathIndex + 1];
            }
            else {
                //alleen versie er achter plaatsen
                ext += "/" + locationparts[applicationpathIndex + 1];
            }
        }

        returnpath += ext;
        return returnpath;
    }

    public static getProtocolAndHostPath = (): string => {
        return location.protocol + "//" + location.host;;
    }

    public static getLocationHref = (): string => {
        return window.location.href;
    }

    private static getApplicationpathIndex(locationparts: string[]): number {
        const syntessAtriumAsp = "Syntess.Atrium.ASP";
        const syntessPortalAsp = "Syntess.Portal.ASP";

        let applicationpathIndex = locationparts.indexOf(syntessAtriumAsp);
        if (applicationpathIndex === -1) {
            applicationpathIndex = locationparts.indexOf(syntessPortalAsp);
        }

        return applicationpathIndex;
    }
}
